<template>
    <nav :class="classes">
        <div v-if="isNavHome && !isProductionStudioDemo && !isWppLogin" class="home-logo">
            <router-link :to="{ name: 'Home' }" data-testid="tob-bar__logo">
                <wpp-logo class="logo" />
            </router-link>
        </div>
        <UserFeedbackMenu />
        <hox-main-nav-button
            v-if="!isUserNotFoundRoute"
            has-circle-border
            :badge-count="notificationsCount"
            :is-active="notificationsDrawerIsVisible"
            :theme="theme"
            :show-tooltip="false"
            data-testid="tob-bar__notifications-button"
            @click="toggleNotificationsDrawerIsVisible"
        >
            <Icon type="md-notifications" data-testid="header__notifications-icon" />
            <template #tooltipContent>Notifications</template>
        </hox-main-nav-button>
        <UserMenu />
    </nav>
</template>

<script lang="ts">
import UserMenu from "@/UserMenu.vue";
import UserFeedbackMenu from "@/UserFeedbackMenu.vue";

import WppLogo from "@/assets/ic_logo.svg";
import { NotificationsAction } from "@/store/modules/notifications";
import type { PropType } from "vue";
import { AppRouteNames } from "./router/constants";

export default {
    name: "FooterNav",
    components: {
        UserMenu,
        UserFeedbackMenu,
        WppLogo
    },

    props: {
        theme: {
            type: String as PropType<"light" | "dark">,
            default: "light",
            validator(value: string) {
                return ["light", "dark"].includes(value);
            }
        }
    },

    computed: {
        isWppLogin() {
            return this.$store.state.auth.isWppLogin;
        },

        isProductionStudioDemo() {
            return import.meta.env.VUE_APP_PRODUCTION_STUDIO_DEMO === "true";
        },

        isNavHome() {
            const defaultRoutes = [
                AppRouteNames.HOME,
                AppRouteNames.SANDBOX,
                AppRouteNames.LOCAL_DEV_NETWORK_ERROR,
                AppRouteNames.PAGE_NOT_FOUND
            ];

            if (defaultRoutes.includes(this.$route.name as string)) {
                return true;
            }

            return false;
        },

        isUserNotFoundRoute() {
            return this.$route.name === AppRouteNames.USER_NOT_FOUND;
        },

        classes() {
            return `${!this.isProductionStudioDemo ? "footer-nav" : ""} footer-nav--${this.theme}`;
        },

        notificationsCount() {
            return this.$store.state.notifications.items.length;
        },

        notificationsDrawerIsVisible: {
            get() {
                return this.$store.state.notifications.drawerIsVisible;
            },

            set(value: boolean) {
                this.$store.dispatch(NotificationsAction.SetDrawerIsVisible, value);
            }
        }
    },

    methods: {
        toggleNotificationsDrawerIsVisible() {
            this.notificationsDrawerIsVisible = !this.notificationsDrawerIsVisible;
        }
    }
};
</script>
<style lang="scss">
@use "@style/variables" as *;

.footer-nav {
    width: 44px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: column;

    svg.logo {
        height: 26px;
        width: 20px;
        margin-bottom: $spacing;
        margin-top: 68px;
    }

    &--dark {
        svg.logo {
            path {
                fill: $hogarth-H-light-fill;
            }
        }
    }
}
</style>
